export const productList = {
  // 电话问律师
  2: {
    intro: '各业务领域专业律师一对一提供电话咨询服务',
    rules: ['1、电话咨询为一次性服务，服务时长为20分钟；', '2、完成付款后，律师5min内主动致电客户，请确保电话通讯畅通；', '3、对于客户提出的订单咨询事项范围以外的问题，如能够在本次电话咨询中予以解答，律师应一并予以解答，' + '且不另行收取费用；对于前述情形，如无法在本次电话咨询中解答的，双方可就该咨询事项的收费、服务时间等另行约定。', '注：购买本服务产品，将视为客户同意手机号授权，确认并遵守上述规定内容。'],
    call: []
  },
  // 合同审查
  3: {
    intro: '律师对客户提供的合同或法律文书进行专业审核并提供具体审核意见',
    rules: ['1、完成付款后，律师10min内主动致电用户沟通需求，请确保电话通讯畅通；', '2、律师应从专业角度对合同合法有效性、完备性、可操作性等进行审核，提出具体修改意见及风险防范意见等，相关意见应尽量具体明确，有可操作性；', '3、除双方另有约定外，律师应在接单后3个工作日内交付审核意见。'],
    call: [{
      txt: '注：购买本服务产品，将视为客户同意手机号授权，确认并遵守上述规定内容。如有疑问，请致电客服电话：',
      id: 31
    }, {
      target: '4008508650',
      type: 'call',
      txt: '4008508650',
      id: 32
    }]
  },
  // 合同代写
  4: {
    intro: '律师根据用户的具体需求，有针对性的起草合同或法律文书',
    rules: ['1、完成付款后，律师10min内主动致电用户沟通需求，请确保电话通讯畅通；', '2、律师提供的内容、形式、结构上应当完备，不应存在明显影响合同效力的条款或明显不利于客户权益的不当内容；', '3、合同内容应符合客户该项订单的个性化需求，如定制时参照了其他文本，则不应出现遗留原文本个性化信息等与客户该项订单需求完全无关的重大错误；', '4、除双方另有约定外，律师应在接单后3个工作日内交付拟好的文书。'],
    call: [{
      txt: '注：购买本服务产品，将视为客户同意手机号授权，确认并遵守上述规定内容。如有疑问，请致电客服电话：',
      id: 41
    }, {
      target: '4008508650',
      type: 'call',
      txt: '4008508650',
      id: 42
    }]
  },
  // 律师查档
  5: {
    intro: '律师提供信息档案查询服务',
    rules: ['1、完成付款后，律师10min内主动致电客户沟通需求，请确保电话通讯畅通；', '2、对于查档机构当日能够出具查询结果的，律师应在取得查档结果后第一时间发送给客户；' + '对于查档机构需要一定期限后出具查询结果的，律师应及时告知客户，并在取得查档结果后第一时间发送给客户；', '3、除双方另有约定外，律师应在客户提供查档所需信息后，3个工作日内到查档机构进行信息查询。'],
    call: [{
      txt: '注：购买本服务产品，将视为客户同意手机号授权，确认并遵守上述规定内容。如有疑问，请致电客服电话：',
      id: 51
    }, {
      target: '4008508650',
      type: 'call',
      txt: '4008508650',
      id: 52
    }]
  }
};